var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2017_887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2017_887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8038 20L13.0185 15.0256C12.6613 15.2817 12.2456 15.4866 11.7714 15.6402C11.2972 15.7939 10.7829 15.8707 10.2287 15.8707C8.77524 15.8707 7.54043 15.3425 6.52426 14.2862C5.50809 13.2298 5 11.9462 5 10.4353C5 8.92446 5.50809 7.64085 6.52426 6.58451C7.54043 5.52817 8.77524 5 10.2287 5C11.6821 5 12.9169 5.52817 13.9331 6.58451C14.9493 7.64085 15.4573 8.92446 15.4573 10.4353C15.4573 11.0243 15.3834 11.5589 15.2356 12.0391C15.0878 12.5192 14.8908 12.9385 14.6444 13.2971L19.4481 18.3099L17.8038 20ZM10.2287 13.4507C11.0416 13.4507 11.7283 13.1594 12.2887 12.5768C12.8492 11.9942 13.1294 11.2804 13.1294 10.4353C13.1294 9.59027 12.8492 8.87644 12.2887 8.29385C11.7283 7.71127 11.0416 7.41997 10.2287 7.41997C9.41573 7.41997 8.72905 7.71127 8.16861 8.29385C7.60818 8.87644 7.32796 9.59027 7.32796 10.4353C7.32796 11.2804 7.60818 11.9942 8.16861 12.5768C8.72905 13.1594 9.41573 13.4507 10.2287 13.4507Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2255525c9116ff4292fa1e51c0d0aac8.svg";
export { ForwardRef as ReactComponent };